export const WAC_STAGING_URL = 'https://qa-wac.internal.atlassian.com';
export const WAC_PROD_URL = 'https://www.atlassian.com';

export const OPSGENIE_SIGNUP_PATH = '/software/opsgenie/try';
// Bundle expansion is used by JSW, JSD & Confluence
export const WAC_BUNDLE_SIGNUP_PATH = '/try/cloud/signup';
export const WAC_SIGNUP_PATH = '/software';
